import {
   SET_WELLNESS_ENTRIES,
   SET_WELLNESS_LOADING,
   SET_WELLNESS_ERROR,
   SET_SELECTED_DATE,
   SET_CURRENT_ENTRY,
   ADD_WELLNESS_ENTRY,
   UPDATE_WELLNESS_ENTRY,
   REMOVE_WELLNESS_ENTRY,
   SET_FORM_DRAFT,
   CLEAR_FORM_DRAFT,
} from '../constants/Wellness';

const initState = {
   entries: [],
   loading: false,
   error: null,
   selectedDate: null,
   currentEntry: null,
   formDraft: null,
};

const wellness = (state = initState, action) => {
   switch (action.type) {
      case SET_WELLNESS_ENTRIES:
         return {
            ...state,
            entries: action.payload,
            error: null,
         };

      case SET_WELLNESS_LOADING:
         return {
            ...state,
            loading: action.payload,
         };

      case SET_WELLNESS_ERROR:
         return {
            ...state,
            error: action.payload,
            loading: false,
         };

      case SET_SELECTED_DATE:
         return {
            ...state,
            selectedDate: action.payload,
         };

      case SET_CURRENT_ENTRY:
         return {
            ...state,
            currentEntry: action.payload,
         };

      case ADD_WELLNESS_ENTRY:
         return {
            ...state,
            entries: [...state.entries, action.payload],
         };

      case UPDATE_WELLNESS_ENTRY:
         return {
            ...state,
            entries: state.entries.map(entry =>
               entry.id === action.payload.id ? action.payload : entry
            ),
            currentEntry:
               state.currentEntry?.id === action.payload.id ? action.payload : state.currentEntry,
         };

      case REMOVE_WELLNESS_ENTRY:
         return {
            ...state,
            entries: state.entries.filter(entry => entry.id !== action.payload),
            currentEntry: state.currentEntry?.id === action.payload ? null : state.currentEntry,
         };

      case SET_FORM_DRAFT:
         return {
            ...state,
            formDraft: action.payload,
         };

      case CLEAR_FORM_DRAFT:
         return {
            ...state,
            formDraft: null,
         };

      default:
         return state;
   }
};

export default wellness;
